<style>
    .salary-desc {
        width          : 70px;
        display        : inline-block;
        overflow       : hidden;
        text-overflow  : ellipsis;
        white-space    : nowrap;
        vertical-align : bottom;
    }

    .edit-salary-btn {
        color  : #50bffe;
        cursor : pointer;
    }
</style>
<template>
    <div>
        <span><span class="salary-desc" :title="value">{{value}}</span> <i class="el-icon-my-bishi edit-salary-btn"
                                                                           @click="showEditDialog"></i></span>
        <el-dialog  title="编辑期望薪资" :visible.sync="showDialog">
            <el-form ref="ruleForm" class="form-beauty" label-width="100px">
                <el-form-item label="期望薪资" prop="salary">
                    <el-input v-model.number="salary" :maxlength="500" type="number" :min="0"
                              placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="submitForm()" type="primary">保存</el-button>
                <el-button @click="showDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                salary: '',
                showDialog: false
            }
        },
        props: {
            id: '',
            value: ''
        },
        watch: {
            value (val) {
                this.salary = val
            }
        },
        methods: {
            showEditDialog () {
                this.salary = this.value
                this.showDialog = true
            },
            submitForm () {
                if (this.salary) {
                    this.$axios.post('/desktop/task/updateExpectSalary.api', {
                        id: this.id,
                        expectSalary: this.salary
                    }).then(res => {
                        this.$emit('input', this.salary)
                        this.$message.success('更新成功')
                        this.showDialog = false
                    })
                } else {
                    this.$message.warning('请输入期望薪资')
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// salaryEditDialog.vue?9583fc10